import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { PropTypes } from 'prop-types';
import ProductCardStaticPlaceholder from 'components/consumer/ProductCardStaticPlaceholder';
const GridLoading = t0 => {
  const $ = _c(2);
  const {
    cardsCount: t1
  } = t0;
  const cardsCount = t1 === undefined ? 6 : t1;
  let t2;
  if ($[0] !== cardsCount) {
    t2 = <>{[...Array(cardsCount)].map(_temp)}</>;
    $[0] = cardsCount;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  return t2;
};
GridLoading.propTypes = {
  cardsCount: PropTypes.number
};
export default GridLoading;
function _temp(item, index) {
  return <div className="ProductCardContainer" key={index}><ProductCardStaticPlaceholder /></div>;
}